import React, { useState } from "react";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { useAuth } from "../auth/useAuth";
import { ChangePasswordModal } from "./ChangePasswordModal";

const ADMIN_PAGES = ["Analytics", "Users"];

const Header = ({ menu, setMenu }) => {
  const { email, isAdmin } = useAuth();
  const [changingPassword, setChangingPassword] = useState(false);

  const userStyle = {
    fontSize: "13px",
    color: "#575757",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  };

  const headerStyle = {
    // width: "1440px",
    height: "50px",
    padding: "20px 0px 20px 20px",
    borderBottom: "1px solid #E0E0E0",
    background: "#FFF",
    position: "fixed",
    top: "0",
    left: "0",
    right: "0",
    alignItems: "center",    
    zIndex: "1000", 
    display: "flex",
  };

  return (
    <div style={headerStyle} data-testid="img4">
      
      <img src="new.png" alt="Logo 1" style={{height:'40px'}} />

      {/* Who you are signed in as. Worth showing on a shared computer, where
          the symptom is otherwise just "why is this data not mine?". */}
      {email ? (
        <div
          style={{ marginLeft: "auto", marginRight: "24px" }}
          data-testid="signed-in-as"
        >
          <UncontrolledDropdown>
            <DropdownToggle
              tag="button"
              caret
              className="btn btn-link p-0"
              style={{
                ...userStyle,
                textDecoration: "none",
                boxShadow: "none",
              }}
              data-testid="user-menu"
            >
              <span>{email}</span>
              {isAdmin ? (
                <span
                  style={{
                    background: "#4A42A0",
                    color: "#FFF",
                    borderRadius: "10px",
                    padding: "1px 8px",
                    fontSize: "11px",
                  }}
                >
                  admin
                </span>
              ) : null}
            </DropdownToggle>
            <DropdownMenu end>
              {/* Analytics reports on the users themselves and Users manages
                  their accounts, so both are admin-only, and live under the
                  username rather than in the sidebar. The backend refuses
                  /api/analytics/* and /api/users to anyone else regardless;
                  hiding the items just avoids offering a dead end. */}
              {isAdmin
                ? ADMIN_PAGES.map((page) => (
                    <DropdownItem
                      key={page}
                      onClick={() => setMenu(page)}
                      style={{
                        fontSize: "13px",
                        color: menu === page ? "#4A42A0" : "#575757",
                      }}
                      data-testid={page.toLowerCase() + "-menu"}
                    >
                      {page}
                    </DropdownItem>
                  ))
                : null}
              {isAdmin ? <DropdownItem divider /> : null}
              <DropdownItem
                onClick={() => setChangingPassword(true)}
                style={{ fontSize: "13px", color: "#575757" }}
                data-testid="change-password-menu"
              >
                Change password
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
          <ChangePasswordModal
            isOpen={changingPassword}
            toggle={() => setChangingPassword(false)}
            email={email}
          />
        </div>
      ) : null}
     
    </div>
  );
};

export default Header;
